import { select } from '@panel/commons/core/themev2';
import { getColor } from '@panel/commons/core/themev3';
import styled, { css } from 'styled-components';

const Container = styled.div`
  width: 100%;
  height: 80px;
`;

const ButtonContainer = styled.div`
  height: 100%;
  max-width: 800px;
  margin: auto;
  padding: 16px ${({ device }) => (device === 'mobile' ? 16 : 24)}px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 2px solid ${select('lightGray')};
  ${({ isEdition, device }) =>
    isEdition &&
    device !== 'mobile' &&
    css`
      justify-content: flex-end;
      gap: 8px;
    `}
`;

const commonBtns = css`
  -webkit-appearance: none;
  outline: none;
  height: 40px;
  border-radius: 8px;
  padding: 0px 12px;
  color: #fff;
  text-shadow: 0 0 0.6px #fff, 0 0 0.6px #fff, 0 0 0.6px #fff;
  :hover {
    cursor: pointer;
    background-color: ${getColor('secondary')};
  }
  :disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

const Submit = styled.button`
  ${commonBtns};
  background-color: ${getColor('primary')};
  display: ${props => props.hide && 'none'};
  min-width: 110px;
  justify-self: flex-end;
  text-align: center;
  font-family: Hind;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 130%;
  ${({ device }) =>
    device === 'mobile'
      ? css`
          height: 48px;
        `
      : ''}
`;

const BackButton = styled.button`
  ${commonBtns};
  color: ${select('black')};
  background-color: transparent;
  display: flex;
  align-items: center;
  padding: 0px 12px;
  visibility: ${({ isVisible }) => (isVisible ? 'visible' : 'hidden')};
  > svg {
    margin-top: 10px;
    margin-right: -11px;
  }
  text-align: center;
  font-family: Hind;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 130%;
  gap: 4px;
  :hover {
    background-color: ${select('neutralDarkGray')};
  }
`;

export { Container, ButtonContainer, BackButton, Submit };
